<template>
  <div>
    <div class="card">
      <div class="card-header animated fadeInRightBig">
        <div class="card-title">Solicitações de marcações pendentes</div>
      </div>
      <div class="card-body">
        <div class="row" v-if="absenceRequests.length">
          <div
            v-for="absenceRequest in absenceRequests"
            :key="absenceRequest.id"
            class="col-md-6 offset-md-3 check-request-card"
          >
            <div class="row mb-3">
              <div class="col-md-9">
                <h6>
                  <b>Colaborador:</b>
                  {{ absenceRequest.user.name }}
                </h6>
                <h6>
                  <b>Data e hora Inicio:</b>
                  {{ format(absenceRequest.start_date) }}
                </h6>
                <h6>
                  <b>Data e hora Final:</b>
                  {{ format(absenceRequest.end_date) }}
                </h6>
                <h6>
                  <b>Motivo:</b>
                </h6>
                <p>{{ absenceRequest.description }}</p>
                <h6 v-if="absenceRequest.downloadFile">
                  <a :href="absenceRequest.downloadFile" target="_blank">Baixar Anexo</a>
                </h6>
                <div v-if="reprovingIds.includes(absenceRequest.id)">
                  <h6>
                    <b>Justificativa:</b>
                  </h6>
                  <textarea
                    rows="5"
                    class="form-control"
                    v-model="absenceRequest.approver_description"
                  ></textarea>
                </div>
              </div>
              <div class="col-md-3">
                <div v-show="!reprovingIds.includes(absenceRequest.id)">
                  <button class="btn btn-yes btn-block" @click="approve(2,absenceRequest)">Aprovar</button>
                  <button class="btn btn-no btn-block" @click="justify(absenceRequest)">Reprovar</button>
                </div>
                <div v-show="reprovingIds.includes(absenceRequest.id)">
                  <button class="btn btn-yes btn-block" @click="approve(3,absenceRequest)">Enviar</button>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="row" v-if="!absenceRequests.length">
          <div class="col-md-6 offset-md-3">
            <div class="alert alert-primary" role="alert">Nenhuma solicitação pendente!</div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data: function() {
    return {
      users: [],
      absenceRequests: {
        id: "",
        status_id: "",
        approver_description: ""
      },
      reprovingIds: []
    };
  },
  methods: {
    approve: function(status_id, absenceRequest) {
      const self = this;
      const api = self.$store.state.api + "absenserequests/approve";
      self.$http
        .post(api, {
          status_id: status_id,
          id: absenceRequest.id,
          approver_description: absenceRequest.approver_description
        })
        .then(response => {
          self.getData();
          self.$message("Sucesso", "Dados registrados com sucesso", "success");
        })
        .catch(error => {
          self.$message("Erro", error.response.data, "error");
        });
    },
    justify(absenceRequests) {
      const self = this;
      let index = self.reprovingIds.findIndex(x => x == absenceRequests.id);
      if (index !== -1) {
        self.reprovingIds.splice(index, 1);
      } else {
        self.reprovingIds.push(absenceRequests.id);
      }
    },
    format(datetime) {
      return moment(datetime).format("DD/MM/YYYY HH:MM:SS");
    },
    getData() {
      const self = this;
      const api =
        self.$store.state.api + "absencerequests?status_id=1&with[]=user";
      self.$http
        .get(api)
        .then(response => {
          self.absenceRequests = response.data.data;
        })
        .catch(error => {
          self.$message("Erro", error.response.data, "error");
        });
    }
  },
  mounted() {
    const self = this;
    self.getData();
  }
};
</script>

<style scoped>
.check-request-card {
  border-radius: 10px;
  border: 1px solid black;
  margin-bottom: 5px;
  background-color: white;
  padding-top: 10px;
}
/* .check-request-card:hover {
    } */
.btn-yes {
  border: 1px solid #2ea2cd;
  background-color: white;
  color: #2ea2cd;
}
.btn-yes:hover {
  border-radius: 1px solid white;
  background-color: #2ea2cd;
  color: white;
}

.btn-no {
  border: 1px solid rgb(255, 70, 70);
  background-color: white;
  color: rgb(255, 70, 70);
}
.btn-no:hover {
  border-radius: 1px solid white;
  background-color: rgb(255, 70, 70);
  color: white;
}
</style>


// WEBPACK FOOTER //
// src/components/AbsenceRequest/Approve.vue